import { Link } from 'react-router-dom';
import Logo from '../asset/logos.png'
import '../css/BizTransport.css';


function Home() {
  const handleClick = () => {
    alert("서비스 준비중입니다");
  };


  return (
<div className="transport-full">

<div className="purchase-nav">
    <a href="https://www.jungdari.com">
      <img src={Logo} alt="Logo" style={{ width: "140px", padding:"10px 0px", paddingLeft:"14px"}} />
    </a>
    <ul className="transport-ul">
    <li style={{ display: "inline-block" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>

    <a href="https://www.jungdari.com/member/register.do"
       target="_blank"
       rel="noopener noreferrer">
    <li className="transport-signup">
      중달이닷컴 회원가입
    </li>
    </a>
    </ul>
</div>

<div style={{border:"1px solid #ddd"}}>
</div>

<div style={{height:"200px", display:"flex"}}>
  <div style={{fontSize:"47px", fontWeight:"bold", margin:"auto", marginTop:"120px"}}>
    서비스 바로가기
  </div>

</div>

<div style={{height:"560px", display:"flex"}}>
  <div style={{margin:"auto", display:"flex", width:"1200px", height:"100%"}}>
    <div className='home_nav_choice' style={{flex:1, display:"flex"}}><><div className='home-nav-one' onClick={handleClick}></div></></div>
    <div className='home_nav_choice' style={{flex:1, display:"flex"}}><Link to='/biztransport'><div className='home-nav-two'></div></Link></div>
    <div className='home_nav_choice' style={{flex:1, display:"flex"}}><Link to='/purchase'><div className='home-nav-three'></div></Link></div>
  </div>

</div>


</div>
  );
}

export default Home;
